import styled from "styled-components";
import AppWrapper from "../../layout/AppWrapper";
import Title from "../../utils/Title";
import { useState } from "react";
import AllDebtors from "../../components/user/debtor/AllDebtors";
import AllCreditors from "../../components/user/debtor/AllCreditors";


function DebtManagement() {

  const [type, settype] = useState('debtor');

  function changeType(e) {
    settype(e);
  }

  return (
    <>
      <AppWrapper
        pagename={"debt"}
      >
        <StyledDebtManagement>

          <Title title={"Debt Management"} btnName={""} />
          {/* Select buttons for Services or Products */}

          <div
            className="d-flex transparent py-2 px-2 br-sm fit-content mx-auto mt-4 justify-content-between pry-border">
            <div
              className={`col br-sm py-1 pry-bold-text pointer text-center px-3 
                    ${ type === 'debtor' ? 'pry-bold light-text' : ('') } `}
              onClick={e => changeType('debtor')}
            >
              Debtors
            </div>
            <div
              className={`col br-sm py-1 pry-bold-text pointer text-center px-3 ${ type === 'creditor' ? 'pry-bold light-text' : ('') } `}
              onClick={e => changeType('creditor')}
            >
              Creditors
            </div>
          </div>

          {/* Select buttons for Services or Products */}
          {type === 'debtor' ?
            <AllDebtors /> :
            <AllCreditors />
          }
        </StyledDebtManagement>



      </AppWrapper>

    </>
  );
}

export default DebtManagement;

const StyledDebtManagement = styled.div`
  

`;